module.exports = __webpack_public_path__ + "media/images/xpass/markers/active/cyclebar-f939cdde7937280df66274989f65e75d.png";